<footer class="container py-5">
  <div class="row">
    <div class="col-12 col-md">
      <img src="../../../assets/images/logo/septa.png"
            height="20" class="d-inline-block align-top" alt="SEPTA Logo">
      <span>SEPTA</span>
      <a href="http://septa.org/site/copyright.html"><small class="d-block mb-3 text-muted">© {{ anio }}</small></a>
    </div>
    <div class="col-6 col-md">
      <h5>Features</h5>
      <ul class="list-unstyled text-small">
        <li><a class="text-muted" routerLink="/system">System Status</a></li>
        <li><a class="text-muted" routerLink="/train">TrainView</a></li>
        <li><a class="text-muted" routerLink="/map">TransitView</a></li>
        <!-- <li><a class="text-muted" routerLink="/schedules">Schedules</a></li> -->
      </ul>
    </div>
    <div class="col-6 col-md">
      <h5>Contact</h5>
      <ul class="list-unstyled text-small">
        <li><a class="text-muted" href="https://www3.septa.org/customerservice/">Online Comment Form</a></li>
        <li><a class="text-muted" href="http://septa.org/claims">Online Claims Form</a></li>
        <li><a class="text-muted" href="http://septa.org/cs/title-vi.html"S>Civil Rights Notices</a></li>
        <li><a class="text-muted" href="https://twitter.com/SEPTA_SOCIAL">SEPTA Social</a></li>
      </ul>
    </div>
    <div class="col-6 col-md">
      <h5>About</h5>
      <ul class="list-unstyled text-small">
        <li><a class="text-muted" href="http://septa.org/access/">Accessibility</a></li>
        <li><a class="text-muted" href="http://septa.org/safety/">Safety &amp; Security</a></li>
        <li><a class="text-muted" href="http://septa.org/about/gm/">General Manager</a></li>
        <li><a class="text-muted" href="http://septa.org/about/board/">SEPTA Board</a></li>
      </ul>
    </div>
    <div class="col-6 col-md">
      <h5>Social</h5>
      <ul class="list-unstyled text-small">
        <li><a class="text-muted" href="http://www.facebook.com/septaphilly">SEPTA on Facebook</a></li>
        <li><a class="text-muted" href="http://septa.org/alert/twitter.html">SEPTA on Twitter</a></li>
        <li><a class="text-muted" href="https://www.youtube.com/user/septaInMotion">SEPTA on Youtube</a></li>
        <li><a class="text-muted" href="http://pinterest.com/septatransit/">SEPTA on Pinterest</a></li>
      </ul>
    </div>
  </div>
</footer>
